import { render, staticRenderFns } from "./EditPaymentMethod.vue?vue&type=template&id=3f506a22&"
import script from "./EditPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./EditPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./EditPaymentMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports